import { render } from "./Attachment.vue?vue&type=template&id=d5394ea4&scoped=true"
import script from "./Attachment.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Attachment.vue?vue&type=script&charset=utf-8&lang=js"

import "./Attachment.vue?vue&type=style&index=0&id=d5394ea4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5394ea4"]])

export default __exports__